// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--1spLw","logo":"styles-module--logo--3Ej-A","text":"styles-module--text--3Ce4S","link":"styles-module--link--1MZJd"};